/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fac_Callout_LinkInputs */

const en_fac_callout_link = /** @type {(inputs: Fac_Callout_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`see Design Room`)
};

const id_fac_callout_link = /** @type {(inputs: Fac_Callout_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lihat Design Room`)
};

/**
* | output |
* | --- |
* | "see Design Room" |
*
* @param {Fac_Callout_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fac_callout_link = /** @type {((inputs?: Fac_Callout_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fac_Callout_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fac_callout_link(inputs)
	return en_fac_callout_link(inputs)
});